import { withServerErrorCode } from '@plone/volto/helpers/Utils/Utils';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import ErrorTemplate from '../ErrorTemplate';

const messages = defineMessages({
  altText: {
    id: 'Sorry, but there seems to be an error…',
    defaultMessage: 'Sorry, but there seems to be an error…',
  },
});

const ServerError = () => {
  const intl = useIntl();

  return (
    <ErrorTemplate
      imageSrc="/errors/error403.png"
      imageAlt={intl.formatMessage(messages.altText)}
      title={
        <FormattedMessage
          id="Sorry, but there seems to be an error…"
          defaultMessage="Sorry, but there seems to be an error…"
        />
      }
      description={
        <>
          <p className="text-up-01 text-sm-up-02">
            <FormattedMessage
              id="We apologize for the inconvenience, but there was an error on this page that you were trying to access."
              defaultMessage="We apologize for the inconvenience, but there was an error on this page that you were trying to access."
            />
          </p>
          <p className="text-up-01 text-sm-up-02">
            <FormattedMessage
              id="If you continue to encounter an error, please contact the {siteAdmin}."
              defaultMessage="If you continue to encounter an error, please contact the {siteAdmin}."
              values={{
                siteAdmin: (
                  <Link className="text-bold" to="/contact-form">
                    <FormattedMessage
                      id="site administration"
                      defaultMessage="site administration"
                    />
                  </Link>
                ),
              }}
            />
          </p>
          <p className="text-up-01 text-sm-up-02">
            <FormattedMessage id="Thank you." defaultMessage="Thank you." />
          </p>
        </>
      }
    />
  );
};

export default withServerErrorCode(500)(ServerError);
